/*
 * @Author: Q in
 * @Date: 2025-11-13 11:45:08
 * @LastEditors: Q in 
 * @LastEditTime: 2026-07-24 10:19:27
 * @FilePath: /new_kefu_pc/src/router/index.js
 * @Description: 路由配置文件
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store/index';
import { Message } from 'element-ui';
import { isMobile } from '@/utils/validate.js';
import { Encrypt, Decrypt } from '@/utils/aes';

Vue.use(VueRouter);
// 白名单，无需登录即可访问的路由
const whiteList = ['/kefu', '/peerVideo.html', '/peerCall.html'];
const routes = [
	{
		path: '/',
		redirect: '/login.html'
	},
	{
		path: '/login.html',
		name: 'AdminLogin',
		meta: {
			title: '客服端登录',
			requiresAuth: false // 添加是否需要登录的标识
		},
		component: () => import('@/views/admin/page/login/index.vue')
	},
	{
		path: '/peerVideo.html',
		name: 'AdminPeerVideo',
		meta: {
			title: '客服端视频组件',
			requiresAuth: false // 需要登录才能访问
		},
		component: () => import('@/views/admin/page/peerVideo/index.vue')
	},
	{
		path: '/peerCall.html',
		name: 'AdminPeerCall',
		meta: {
			title: '客服端语音视频通话',
			requiresAuth: false // 无需登录即可访问
		},
		component: () => import('@/views/admin/page/peerCall/index.vue')
	},
	{
		path: '/home.html',
		meta: {
			title: '客服端首页',
			requiresAuth: true, // 需要登录才能访问
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminHome', // 修改为不同的name
				meta: {
					title: '客服端首页',
					requiresAuth: true,
				},
				component: () => import('@/views/admin/page/home/index.vue')
			}
		]
	},
	{
		path: '/serviceManagement.html',
		meta: {
			title: '客服管理',
			requiresAuth: true, // 需要登录才能访问
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminServiceManagement', // 修改为不同的name
				meta: {
					title: '客服管理',
					requiresAuth: true,
                    // auth: ['admin'],
				},
				component: () => import('@/views/admin/page/serviceManagement/index.vue')
			}
		]
	},
	{
		path: '/userManagement.html',
		meta: {
			title: '用户管理',
			requiresAuth: true, // 需要登录才能访问
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminUserManagement', // 修改为不同的name
				meta: {
					title: '用户管理',
					requiresAuth: true,
				},
				component: () => import('@/views/admin/page/userManagement/index.vue')
			}
		]
	},
	{
		path: '/workOrder.html',
		meta: {
			title: '工单管理',
			requiresAuth: true, // 需要登录才能访问
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminWorkOrder', // 修改为不同的name
				meta: {
					title: '工单管理',
					requiresAuth: true
				},
				component: () => import('@/views/admin/page/workOrder/index.vue')
			}
		]
	},
    {
		path: '/knowledgeBase.html',
		meta: {
			title: '知识库',
			requiresAuth: true, // 需要登录才能访问
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminKnowledgeBase', // 修改为不同的name
				meta: {
					title: '知识库',
					requiresAuth: true
				},
				component: () => import('@/views/admin/page/knowledgeBase/index.vue')
			}
		]
	},
	{
		path: '/emailPasswordEditApply.html',
		meta: {
			title: '邮箱密码修改申请',
			requiresAuth: true, // 需要登录才能访问
            auth: [2, 3, 4, 6, 7, 12],
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminEmailPasswordEditApply', // 修改为不同的name
				meta: {
					title: '邮箱密码修改申请',
					requiresAuth: true
				},
				component: () => import('@/views/admin/page/emailPasswordEditApply/index.vue')
			}
		]
	},
    {
		path: '/emailPasswordEditRecord.html',
		meta: {
			title: '邮箱密码修改记录',
			requiresAuth: true, // 需要登录才能访问
            auth: [2, 3, 4, 6, 7, 12],
		},
		component: () => import('@/views/admin/index.vue'),
		children: [
			{
				path: '',
				name: 'AdminEmailPasswordEditRecord', // 修改为不同的name
				meta: {
					title: '邮箱密码修改记录',
					requiresAuth: true
				},
				component: () => import('@/views/admin/page/emailPasswordEditRecord/index.vue')
			}
		]
	},
	{
		path: '*',
		name: 'NotFound',
		meta: {
			title: '页面不存在'
		},
		component: () => import('@/views/error/404.vue')
	}
];

const router = new VueRouter({
	mode: 'history', // 启用 History 模式
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 每次路由跳转时，滚动到页面顶部
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

// 路由守卫
router.beforeEach((to, from, next) => {
    if (to.query.order_sn) localStorage.setItem('order_sn', to.query.order_sn);
	// 设置页面标题
	if (to.meta && to.meta.title) {
		document.title = to.meta.title + ' - 游戏客服平台';
	}

	let userInfo = Store.state.userInfo ? JSON.parse(Decrypt(Store.state.userInfo)) : {};
    // 白名单直接放行
	if (whiteList.includes(to.path)) {
		next();
		return;
	}

    // 1. 未登录 -> 跳转登录页
	if (!userInfo.token && to.path != '/login.html') {
		next('/login.html');
		return;
	}

    // 2. 已登录但访问登录页 -> 跳转首页
    if (userInfo.token && to.path == '/login.html') {
		next('/home.html');
		return;
	}

    // 3. 检查是否有权限访问当前路由
    // auth 配置在父路由 meta 上，通过 to.matched 遍历所有匹配的路由记录
    const authRoute = to.matched.find((record) => record.meta && record.meta.auth);
    if (authRoute && !authRoute.meta.auth.includes(userInfo.id)) {
        Message({
            message: '您没有权限访问' + (to.meta.title || '该页面'),
            type: 'warning'
        });
        Store.commit('setActiveActiveTab', { id: 1 });
        next('/home.html');
        return;
    }

	next();
});

router.afterEach((to, from) => {
	Store.state.asideList.forEach((item) => {
	    if (item.path == to.path) Store.commit('setActiveActiveTab', item);
	})
})

export default router;
